import React, {useState} from "react";
import {Button, Dialog, DialogActions, DialogContent} from "@mui/material";
import {ClosableDialogTitle} from "@atttomyx/react-components";
import {ChooseNodeForm} from "../forms";
import {forms} from "@atttomyx/shared-utils";

const freshData = () => {
    return {
        nodeId: null,
        valid: false,
    }
};

const ChooseNodeDialog = (props) => {
    const {title, nodes, excludedIds, onCancel, onOk} = props;
    const [data, setData] = useState(freshData());

    return <Dialog
        open={true}
        aria-labelledby="choose-node-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            {title}
        </ClosableDialogTitle>
        <DialogContent className="choose-node-dialog">
            <ChooseNodeForm
                nodes={nodes}
                excludedIds={excludedIds}
                data={data}
                onChange={setData}
            />
        </DialogContent>
        <DialogActions>
            <Button
                color="primary"
                disabled={!data.valid || !forms.differ(freshData(), data)}
                onClick={() => onOk(data.nodeId)}
            >
                Ok
            </Button>
        </DialogActions>
    </Dialog>
}

export default ChooseNodeDialog;
